import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/pendampingan',
    name: 'pendampingan',
    component: () => lazyLoadView(import('@views/gtk/diklat/pendampingan/pa/List')),
    meta: {
      title: 'Laporan PMO & Pendampingan Individu',
    },
  },
  {
    path: '/pendampingan/:detail_id',
    name: 'detail-pendampingan',
    component: () => lazyLoadView(import('@views/gtk/diklat/pendampingan/pa/Detail')),
    meta: {
      title: 'Detail Laporan PMO & Pendampingan Individu',
    },
  },
  {
    path: '/feedback',
    name: 'diklat-feedback',
    component: () => lazyLoadView(import('@views/gtk/diklat/pendampingan/feedback/Index')),
    meta: {
      title: 'Umpan Balik Kegiatan Pendampingan',
    },
  },
  {
    path: '/rekap-lokakarya',
    name: 'rekap-lokakarya',
    component: () => lazyLoadView(import('@views/gtk/lokakarya/Rekap')),
    meta: {
      title: 'Rekapan Lembar Umpan Balik Kegiatan Pendampingan',
    },
  },
  {
    path: '/diklat-iht',
    name: 'diklat-iht',
    component: () => lazyLoadView(import('@views/gtk/iht/IndexFsp')),
    meta: {
      title: 'Laporan Pelaksanaan IHT',
    },
  },
  {
    path: '/diklat-kp',
    name: 'diklat-pendampingan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/dkp/List')),
    meta: {
      title: 'Kelola Pendampingan oleh IN (Instruktur ad Interim)',
      api: 'kp',
    },
  },
  {
    path: '/diklat-kp/:detail_id',
    name: 'detail-diklat-pendampingan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/dkp/Detail')),
    meta: {
      title: 'Detail Kelompok Pendampingan IN',
      api: 'kp',
      view: true,
    },
  },
];
